import MetaService from '@/services/MetaService'

const createMetaModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    metas: []
  },
  actions: {
    getMetas: ({ commit, state }) => {
      MetaService.getMetas(state.pageSize, state.page)
        .then((data) => {
          commit('SET_METAS', { metas: data.metas })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, commit, state }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getMetas')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_METAS: (state, { metas }) => {
      state.metas = metas
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createMetaModule
